import {
  Form,
  Input,
  Button,
  Typography,
  Carousel,
  Modal,
  Spin,
  Alert
} from "antd";
import FormItem from "antd/lib/form/FormItem";
import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { ErrorMessages } from "constants/index";
import { AppLogoIcon } from "components/svg-icons";
import PiiConsent from "components/widgets/pii-consent";
import { ssoLogin } from "services/auth";
import { SSOLoginRequest } from "models/user";
import { LoadingOutlined } from "@ant-design/icons";

const { Title } = Typography;

function SSOLogin() {
  const history = useHistory();

  const [loader, setLoader] = useState(false);
  const [isErrorOnValidation, setIsErrorOnValidation] = useState(false);
  const [message, setMessage] = useState("");
  const [loginForm] = Form.useForm();

  const slider: any = useRef();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");
    const email = params.get("email");
    loginForm.setFieldsValue({ email });

    if (error) {
      setIsErrorOnValidation(true);
      setMessage(error);
    }
  }, [loginForm]);

  const onLoginFinish = useCallback(
    async (event: SSOLoginRequest) => {
      const res: any = await ssoLogin({
        email: event.email
      });

      if (res.status === 200) {
        setLoader(true);
        if (
          res.data.message === "User not found" ||
          res.data.message === "No SSO provider associated with this user"
        ) {
          setLoader(false);
          const emailParam = event.email;
          history.push(`/Login?email=${encodeURIComponent(emailParam)}`);
        } else {
          setTimeout(() => {
            try {
              window.location.href = res.data.loginUrl;
              setTimeout(() => {
                setLoader(false);
              }, 5000);
            } catch (error: any) {
              setLoader(false);
              Modal.error({
                content:
                  error?.response?.data?.error ||
                  error?.message ||
                  "Unable to start SSO sign-in. Please try again."
              });
            }
          }, 1000);
        }
      } else if (res.response?.status === 403) {
        setLoader(false);
        history.push(
          `/account-locked?email=${encodeURIComponent(event.email)}`
        );
      } else {
        setLoader(false);
        history.push(`/Login?email=${encodeURIComponent(event.email)}`);
      }
    },
    [history]
  );

  return (
    <div className="login">
      <div className="login-form">
        <div style={{ margin: "auto", display: "block" }}>
          <AppLogoIcon />
        </div>
        <div className="login-logo">
          <Title level={3} className="mt-3">
            Login
          </Title>
        </div>
        <Carousel
          dots={false}
          afterChange={() => {}}
          ref={(ref) => {
            slider.current = ref;
          }}
          speed={250}
          infinite={false}
          swipe={false}
          swipeToSlide={false}
          draggable={false}
        >
          <div className="px-1">
            <Form
              onFinish={onLoginFinish}
              form={loginForm}
              labelCol={{ span: 50 }}
              wrapperCol={{ span: 30 }}
              scrollToFirstError
              layout="vertical"
            >
              <FormItem
                name="email"
                label="Email"
                rules={[
                  {
                    required: true,
                    validateTrigger: "onSubmit",
                    message: ErrorMessages.EmailRequired
                  },
                  {
                    type: "email",
                    validateTrigger: "onSubmit",
                    message: ErrorMessages.EmailRequired
                  }
                ]}
              >
                <Input placeholder="Enter Email" />
              </FormItem>
              <div className="pt-4">
                <Button
                  type="primary"
                  htmlType="submit"
                  size="middle"
                  disabled={loader}
                  className="w-full"
                >
                  Continue
                </Button>
              </div>
              {loader && (
                <div className="pt-[15px]">
                  <Spin
                    indicator={<LoadingOutlined spin />}
                    size="small"
                    className="pr-[5px]"
                  />
                  Redirecting to your organization&apos;s Single Sign On
                </div>
              )}
              {isErrorOnValidation && (
                <div className="pt-[15px]">
                  <Alert
                    message={message}
                    type="error"
                    className="text-xs mt-1 mb-2 rounded-lg"
                    showIcon
                    action={
                      <a
                        href="/forgot_password"
                        className="text-gray-800 hover:text-gray-800 underline hover:underline"
                      >
                        Forgot password?
                      </a>
                    }
                  />
                </div>
              )}
            </Form>
          </div>
        </Carousel>
      </div>
      <PiiConsent className="w-[350px] text-center text-xs text-[#949492] pt-7" />
    </div>
  );
}

export default SSOLogin;
